import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Tests the *primary* pointer, deliberately not `any-hover`: a touch laptop
 * whose primary pointer is a trackpad should behave like the desktop it is,
 * even though one of its pointers (the screen) cannot hover. Also not a width
 * breakpoint: a narrow desktop window still hovers.
 */
const HOVER_MEDIA_QUERY = "(hover: hover)";

/**
 * True on a device whose primary pointer can hover (mouse, trackpad), which the
 * file browsers use to decide two things:
 *  - clicks follow the desktop select-then-open conventions rather than the tap
 *    ones (tap opens, long-press selects);
 *  - the selection checkbox is revealed on hover instead of staying visible,
 *    which without a hover would leave no way to surface it.
 *
 * Reactive, so a device that gains or loses hover (a tablet with a mouse
 * attached, or the browser's device emulation) re-renders instead of keeping the
 * value it happened to have at mount.
 */
export const useHasHover = (): boolean => useMediaQuery(HOVER_MEDIA_QUERY);
